import * as _ from "lodash";
export default function(arr, field) {
  return _.uniqBy(arr, field);
}
